import LocalStorageLanguage from './LocalStorageLanguage';

export default LocalStorageLanguage;
